import { Link } from "react-router-dom";

const GOOGLE_MAPS_URL = "https://www.google.com/maps/place/OYA+PHONE/@48.5502334,-4.7180491,17z/data=!4m15!1m8!3m7!1s0x48169c030933aacd:0xc29a9a477478bda9!2s7+Quelerec,+29840+Landunvez!3b1!8m2!3d48.5502334!4d-4.7180491!16s%2Fg%2F11crt85k0h!3m5!1s0x48169d806c16aaf1:0xc1f9079025809aee!8m2!3d48.5502296!4d-4.7180396!16s%2Fg%2F11j4qtr__v?entry=ttu";

export default function Contact() {
  return (
    <div className="animate-fade-in">
      {/* Hero */}
      <section className="relative bg-oya-black pt-28 pb-12 md:pt-36 md:pb-16 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="inline-block px-4 py-1.5 bg-oya-red/20 rounded-full mb-6">
            <span className="text-oya-red-light text-sm font-medium">/ CONTACT</span>
          </div>
          <h1 className="font-serif text-3xl md:text-5xl lg:text-6xl font-bold text-white max-w-3xl leading-tight">
            Prenons rendez-vous
          </h1>
          <p className="mt-6 text-white/70 text-base md:text-lg max-w-xl">
            OYA PHONE est ouvert du mardi au samedi, uniquement sur rendez-vous.
          </p>
        </div>
      </section>

      {/* Contact Cards */}
      <section className="py-16 md:py-24 px-4 bg-white">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {/* Call */}
            <a
              href="tel:0651004790"
              className="group p-6 md:p-8 rounded-xl bg-oya-cream hover:bg-oya-black transition-all duration-300 text-center"
            >
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-oya-red/10 group-hover:bg-oya-red/20 transition-colors mb-5">
                <i className="ri-phone-line text-oya-red text-2xl" />
              </div>
              <h3 className="text-lg font-bold text-oya-black group-hover:text-white transition-colors mb-2">
                Appeler
              </h3>
              <p className="text-sm text-oya-gray-medium group-hover:text-white/70 transition-colors">
                06 51 00 47 90
              </p>
            </a>

            {/* Email */}
            <a
              href="mailto:oyaphone29@gmail.com"
              className="group p-6 md:p-8 rounded-xl bg-oya-cream hover:bg-oya-black transition-all duration-300 text-center"
            >
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-oya-red/10 group-hover:bg-oya-red/20 transition-colors mb-5">
                <i className="ri-mail-line text-oya-red text-2xl" />
              </div>
              <h3 className="text-lg font-bold text-oya-black group-hover:text-white transition-colors mb-2">
                Envoyer un email
              </h3>
              <p className="text-sm text-oya-gray-medium group-hover:text-white/70 transition-colors">
                oyaphone29@gmail.com
              </p>
            </a>

            {/* Maps */}
            <a
              href={GOOGLE_MAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="group p-6 md:p-8 rounded-xl bg-oya-cream hover:bg-oya-black transition-all duration-300 text-center"
            >
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-oya-red/10 group-hover:bg-oya-red/20 transition-colors mb-5">
                <i className="ri-map-pin-line text-oya-red text-2xl" />
              </div>
              <h3 className="text-lg font-bold text-oya-black group-hover:text-white transition-colors mb-2">
                Itinéraire
              </h3>
              <p className="text-sm text-oya-gray-medium group-hover:text-white/70 transition-colors">
                7, Quélerec, Landunvez
              </p>
            </a>
          </div>
        </div>
      </section>

      {/* Info + Map */}
      <section className="py-16 md:py-24 px-4 bg-oya-cream">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-start">
          {/* Info */}
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-oya-black mb-6">
              Coordonnées
            </h2>
            <div className="space-y-5">
              <div>
                <p className="text-sm font-semibold text-oya-black uppercase tracking-wider mb-1">Adresse</p>
                <p className="text-oya-gray-medium">7, Quélerec</p>
                <p className="text-oya-gray-medium">29840 Landunvez</p>
              </div>
              <div>
                <p className="text-sm font-semibold text-oya-black uppercase tracking-wider mb-1">Téléphone</p>
                <a href="tel:0651004790" className="text-oya-gray-medium hover:text-oya-red transition-colors">
                  06 51 00 47 90
                </a>
              </div>
              <div>
                <p className="text-sm font-semibold text-oya-black uppercase tracking-wider mb-1">Email</p>
                <a href="mailto:oyaphone29@gmail.com" className="text-oya-gray-medium hover:text-oya-red transition-colors">
                  oyaphone29@gmail.com
                </a>
              </div>
              <div>
                <p className="text-sm font-semibold text-oya-black uppercase tracking-wider mb-1">Horaires</p>
                <p className="text-oya-gray-medium">Mardi – Samedi</p>
                <p className="text-oya-gray-medium">10h00 – 12h30 / 15h00 – 18h30</p>
                <p className="text-oya-red text-sm mt-1">Fermé dimanche et lundi</p>
              </div>
              <div>
                <p className="text-sm font-semibold text-oya-black uppercase tracking-wider mb-1">Fonctionnement</p>
                <p className="text-oya-gray-medium">Uniquement sur rendez-vous</p>
              </div>
            </div>
          </div>

          {/* Google Maps */}
          <div className="space-y-4">
            <div className="rounded-xl overflow-hidden border border-oya-gray-light bg-white aspect-[4/3]">
              <iframe
                title="Localisation OYA PHONE"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2199.6!2d-4.7180396!3d48.5502296!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48169d806c16aaf1%3A0xc1f9079025809aee!2sOYA%20PHONE!5e0!3m2!1sfr!2sfr!4v1747913600000!5m2!1sfr!2sfr"
                className="w-full h-full"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
            <a
              href={GOOGLE_MAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm text-oya-red font-medium hover:underline"
            >
              <i className="ri-external-link-line" />
              Voir la page Google Maps de OYA PHONE
            </a>
          </div>
        </div>
      </section>

      {/* CTA Repair */}
      <section className="py-16 md:py-24 px-4 bg-oya-black">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
            Votre appareil est en panne ?
          </h2>
          <p className="text-white/70 mb-8">
            Contactez OYA PHONE dès maintenant pour un rendez-vous de réparation.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="tel:0651004790"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-oya-red text-white font-medium rounded-full hover:bg-oya-red-dark transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line" />
              Appeler maintenant
            </a>
            <Link
              to="/reparation"
              className="inline-flex items-center gap-2 px-8 py-3.5 border-2 border-white/30 text-white font-medium rounded-full hover:bg-white hover:text-oya-black transition-colors whitespace-nowrap"
            >
              <i className="ri-tools-line" />
              Voir les réparations
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}